import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface ClubsExportRequest extends EntityExportRequest {
  /** the id of the club to export, defaults to all clubs */
  readonly id?: number;
  /** the id of the district of which to export the related clubs, defaults to all clubs */
  readonly districtId?: number;
  /** the id of the competition season of which to export the related clubs, defaults to all clubs */
  readonly competitionSeasonId?: number;
}

/**
 * This event can be fired to indicate that a service requires clubs.
 * Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@see ClubsExportRequest.targetBucket} using
 * the {@see ClubsExportRequest.transactionId} as prefix (sub-folder).
 */
export class ClubsExportRequested extends DomainEvent<ClubsExportRequest> {}
